import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, pathAllowed } from '@/lib/auth';
import { Loader2, Lock } from 'lucide-react';

export function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--background))]">
        <Loader2 className="h-8 w-8 animate-spin text-[hsl(var(--primary))]" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // Role check (1) explicit allowedRoles or (2) global pathAllowed map
  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <ForbiddenPage />;
  }
  if (!pathAllowed(user.role, location.pathname)) {
    return <ForbiddenPage />;
  }

  return children;
}

function ForbiddenPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--background))] p-6">
      <div className="text-center max-w-md">
        <div className="h-16 w-16 mx-auto rounded-full bg-red-100 dark:bg-red-900/30 grid place-items-center mb-4">
          <Lock className="h-8 w-8 text-red-600 dark:text-red-400" />
        </div>
        <h1 className="font-heading text-2xl font-bold mb-2">403 — Acceso denegado</h1>
        <p className="text-[hsl(var(--muted-foreground))] mb-4">
          No tienes permisos para acceder a esta página. Habla con tu administrador si crees que es un error.
        </p>
        <a href="/dashboard" className="text-[hsl(var(--primary))] underline">Volver al panel</a>
      </div>
    </div>
  );
}
